export class Utility {
  static getSideMachineIconKey(parentStatusImagePrefix: string, machineIcon: string): string {
    parentStatusImagePrefix = parentStatusImagePrefix ? parentStatusImagePrefix.replace(/\s+/g, '-') : null;
    let key = 'status-side-';

    if (machineIcon) {
      key += `${machineIcon.toLowerCase()}-`;
    }

    if (parentStatusImagePrefix) {
      key += parentStatusImagePrefix.toLowerCase();
    } else {
      key += 'sin-estado';
    }

    return key;
  }
}
